import React from 'react'

import classNames from 'classnames'

import { Box } from 'ui/components/Box'
import { Headline } from 'ui/components/Text'

import { useAppSettingsPageState } from './hooks/useAppSettingsPageState'

import { AppSettingsPageHeaderStyle } from './AppSettingsPage.css'

type AppSettingsPageProps = React.ComponentProps<typeof Box> & {
    title: string
    actions?: React.ReactNode
}

export const AppSettingsPage: React.FC<AppSettingsPageProps> = ({
    children,
    className,
    title,
    actions,
    ...props
}) => {
    const { wrapperRef } = useAppSettingsPageState()

    return (
        <Box ref={wrapperRef} height="full" width="full" overflowX="hidden" overflowY="auto">
            <Box
                flex
                center
                justifyContent="space-between"
                gap="s"
                py="2xl"
                px="2xl"
                background="surface"
                position="sticky"
                top={0}
                className={classNames(AppSettingsPageHeaderStyle, className)}
                {...props}
            >
                <Headline size="s">{title}</Headline>
                {actions && (
                    <Box flex center gap="m">
                        {actions}
                    </Box>
                )}
            </Box>
            <Box pt="m" pb="xl" px="2xl">
                {children}
            </Box>
        </Box>
    )
}
